import { useUserStore } from '@/modules/Auth/useUserStore'
import { loadProfile as backendLoadProfile } from '@/backend/darwin/loadProfile'

export const useUserProfileLoader = (): {
  loadProfile: () => Promise<void>
} => {
  const userStore = useUserStore()

  const loadProfile = async (): Promise<void> => {
    if (userStore.loadingUser) {
      return
    }
    userStore.loadingUser = true
    const response = await backendLoadProfile()
    if (response.ok) {
      userStore.currentUser = response.data
    }
    userStore.loadingUser = false

    // we may want to show a toast at some point here, or return some sort of result
    // or set some sort of error state onto the store
    // but at the moment this code was migrated, there was no such behavior
  }

  return { loadProfile }
}
